var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGenderMale = function SvgGenderMale(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 200 226",
    role: "img"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".gender-male_svg__st0{fill:#45add2}.gender-male_svg__st1{fill:#0f88d3}.gender-male_svg__st4{fill:#11003f}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M114.237 4.504c35.3 0 63.9 28.6 63.9 63.9s-28.6 63.9-63.9 63.9h-53.6c-5.7 0-10.3-4.6-10.3-10.3v-53.6c-.1-35.3 28.6-63.9 63.9-63.9",
    className: "gender-male_svg__st0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.237 66.504v33.9h-4.5c-1.1 0-2.3-.2-3.4-.5-1.5-.6-3.2-1.6-3.2-3.7.1-3.8 11.1-29.7 11.1-29.7",
    className: "gender-male_svg__st1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M170.637 180.604h-63.9l-20.6-80.1h63.9z",
    className: "gender-male_svg__st0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M354.9 3255.5s-5.5-1.7-12.9-4.1c-2.4 1.5-1.5 4.1 0 4.1z",
    style: {
      fill: "#0078db"
    },
    transform: "translate(-291.663 -3146.796)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m354.9 3255.5-12.9 5c-1.8-1-1.3-4.4 0-5z",
    style: {
      fill: "#51bcf5"
    },
    transform: "translate(-291.663 -3146.796)"
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M128.437 80.404s-11.2-3.7-16.9 21.6h-6.3s5.3-22.6 0-60.9c-25.3 2.5-43.6-7.5-43.6-7.5s3.9-30.8 52.6-30.8 67.3 35.8 67.3 67.1-26 53.3-26 53.3-27.1 5.4-27.1-18.9z",
    className: "gender-male_svg__st4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M117.337 85.104s5.5-10.9 17.6-10.9 12.7 21.3.1 30.9-20.9 3.6-20.9 3.6z",
    className: "gender-male_svg__st0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M94.537 132.304h14.3l-11.3 11.3z",
    className: "gender-male_svg__st1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M138.237 152.304c-60.2 0-61.2 73.7-61.2 73.7h122.9c.1 0-1.5-73.7-61.7-73.7",
    className: "gender-male_svg__st0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M358.6 3276.7c-1.1 0-1.9-.9-1.9-1.9v-18.7c0-1.1.9-1.9 1.9-1.9 1.1 0 1.9.9 1.9 1.9v18.7c0 1-.8 1.9-1.9 1.9",
    style: {
      fill: "#140049"
    },
    transform: "translate(-291.663 -3146.796)"
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M68.837 107.604c-.1-.6-.4-1.1-1-1.3l-17.4-5.5c-.8-.2-1.6.2-1.8 1-.2.7.2 1.5.9 1.8l13.5 4.3c.4.1.6.6.5 1-.1.2-.2.4-.5.5l-13.4 5.3c-.5.2-.8.6-.9 1.1v13.4c0 3 2.4 5.4 5.4 5.4h8.3c3.5 0 6.4-2.9 6.4-6.4zM55.937 67.104c-.6.1-.9.6-.8 1.2.1.4.3.7.7.8l9 3.3c2 .7 3.9 1.4 5.9 2.1 1.1.3 2.2.7 3.3 1 .5.1 1.1-.2 1.3-.7.1-.4 0-.8-.3-1-.9-.8-1.8-1.6-2.8-2.3-1.9-1.3-3.9-2.3-6-3.1s-4.4-1.2-6.7-1.4c-1.2-.1-2.4-.1-3.6.1",
    className: "gender-male_svg__st4"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M346.8 3228.8c6.2 0 12.4-1 18.3-2.8",
    style: {
      fill: "#11003f",
      stroke: "#140049",
      strokeWidth: 2.879,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    transform: "translate(-291.663 -3146.796)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.7 3228.3v-6.6",
    style: {
      fill: "none",
      stroke: "#140049",
      strokeWidth: 2.159,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    transform: "translate(-291.663 -3146.796)"
  }));
};
export default SvgGenderMale;